import _ from 'lodash';

const reApplyDiscountForMultiPurchase = (registrations) => {
  for (let i = 0; i < registrations.length; i++) {
    const registration = registrations[i];
    if (registration.productType === 'family'
      || (registration.discountVoucher && registration.discountVoucher.voucherType === 'entity')) {
      // eslint-disable-next-line no-continue
      continue;
    }

    if (registration.productType !== 'family') {
      // Filter out regos in same event
      const sameEventRegos = _.filter(registrations, (rego) => rego.entityId === registration.entityId);
      // Find index of current registration by product & member id, which is unique
      const index = _.findIndex(sameEventRegos, (re) => _.get(re, 'product._id') === _.get(registration, 'product._id') && re.memberId === registration.memberId);

      const formatDisplayPrice = (amount, type) => {
        const p = amount;
        if (type === 'dollar') {
        // p = amount / 100;
          return '';
        }
        return `(${p}%)`;
      };

      registration.discounts = _.filter(registration.discounts, (d) => !d.isMultiRegoDiscount);
      if (index > -1 && _.get(registration, 'multipleRegoDiscounts')) {
        const currentOrder = index + 1;
        const discount = _.find(registration.multipleRegoDiscounts, (s) => s.order === currentOrder || (currentOrder >= s.order && s.rest === true));
        if (discount) {
          const discountObject = {
            _id: discount._id,
            amount: discount.amount,
            description: '',
            name: `Multiple Registration Discount ${formatDisplayPrice(discount.amount, discount.type)}`,
            type: discount.type,
            isMultiRegoDiscount: true
          };
          registration.discounts = _.concat(registration.discounts, [discountObject]);
        }
      }

      if (_.get(registration, 'multipleSaleableItemDiscounts') && registration.saleableItems.length) {
        for (let saleableItemIndex = 0; saleableItemIndex <= registration.saleableItems.length - 1; saleableItemIndex++) {
          const saleableItem = registration.saleableItems[saleableItemIndex];
          if (saleableItem) {
            let maxNo = 0;
            for (let saleableDiscIndex = 0; saleableDiscIndex <= registration.multipleSaleableItemDiscounts.length - 1; saleableDiscIndex++) {
              if (saleableItem.qty >= saleableDiscIndex + 2) {
                maxNo = saleableDiscIndex;
              }
            }
            if (saleableItem.qty >= 2) {
              const sDiscount = registration.multipleSaleableItemDiscounts[maxNo];
              if (sDiscount) {
                const discountObject = {
                  _id: sDiscount._id,
                  amount: sDiscount.amount,
                  description: '',
                  name: `Multiple Registration Discount - ${saleableItem.name} ${formatDisplayPrice(sDiscount.amount, sDiscount.type)}`,
                  type: sDiscount.type,
                  isMultiRegoDiscount: true,
                  isSaleableItem: true,
                  saleableItem: saleableItem._id
                };
                registration.discounts = _.concat(registration.discounts, [discountObject]);
              }
            }
          }
        }
      }
    }
  }
  return registrations;
};

export default {
  namespaced: true,
  state: {
    registrations: [],
    confirmation: [],
    membershiptoUpgrade: {},
    pendingRegistration: undefined,
    pendingRequiredRegos: [],
    saleableItems: [],
    transactionFee: undefined,
    currentMember: {},
    checkoutTotalDiscount: {
      discountVoucher: {
        error: '',
        code: '',
        redeemed: false,
        redeemedAmount: 0,
      }
    },
    regoDiscounts: [
      {
        _id: Math.floor(100000 + Math.random() * 900000),
        discountVoucher: {
          error: '',
          code: '',
          redeemed: false
        },
        type: undefined,
        productIds: [],
      }
    ],
    selectedBulkMembers: [],
    indvCartTotal: 0,
    indvPayTodayTotal: 0,
    totalDiscount: 0,
  },
  mutations: {
    setIndvCartTotal(state, payload) {
      state.indvCartTotal = payload.indvCartTotal;
      state.indvPayTodayTotal = payload.indvPayTodayTotal;
    },
    successful(state, payload = []) {
      // copy all registrations into confirmations
      state.confirmation = [...state.registrations, ...payload];
    },
    setConfirmation(state, payload) {
      // check if the rego is already in the confirmation, check the product._id and memberId
      const index = _.findIndex(state.confirmation, (rego) => rego.product._id === payload.product._id && rego.memberId === payload.memberId);
      if (index > -1) {
        state.confirmation[index] = payload;
      } else {
        state.confirmation.push(payload);
      }
    },
    clearCart(state) {
      state.registrations = [];
      state.saleableItems = [];
      state.regoDiscounts = [];
      state.selectedBulkMembers = [];
      state.membershiptoUpgrade = {};
      state.pendingRegistration = undefined;
      state.pendingRequiredRegos = [];
    },
    clearConfirmations(state) {
      state.confirmation = [];
      state.totalWithSaleableItems = 0;
    },
    setTotalWithSaleableItems(state, payload) {
      state.totalWithSaleableItems = payload;
    },
    setTotalDiscount(state, payload) {
      state.totalDiscount = payload;
    },
    setConfirmations(state, payload) {
      console.log('setConfirmations', payload);
      // Merge new confirmations with existing ones
      state.confirmation = state.confirmation.concat(payload);
      console.log('state.confirmation', state.confirmation);
      // Clear the registrations
      state.registrations = [];
    },
    setPendingRegistration(state, payload) {
      state.pendingRegistration = payload;
    },
    setPendingRequiredRego(state, payload) {
      // If payload is an array, set it directly, otherwise add to array
      if (Array.isArray(payload)) {
        state.pendingRequiredRegos = payload;
      } else {
        state.pendingRequiredRegos.push(payload);
      }
    },
    add(state, registration) {
      console.log('adding rego', registration);
      // check the current state registrations, if there's any registration with productType === 'team', delete it first
      // if (registration.productType !== 'team') {
      //   state.registrations = _.filter(state.registrations, (rego) => rego.productType !== 'team');
      // }
      if (registration.productType === 'indv') {
        if (state.registrations.find((rego) => _.get(rego, 'product._id') === _.get(registration, 'product._id')
          && _.get(rego, 'memberId') === _.get(registration, 'memberId'))) {
          console.log('already exists - individual registration');
          return;
        }
      } else if (registration.productType === 'indv-to-team') {
        if (state.registrations.find((rego) => _.get(rego, 'product._id') === _.get(registration, 'product._id')
          && _.get(rego, 'memberId') === _.get(registration, 'memberId')
          && _.get(rego, 'team.name') === _.get(registration, 'team.name'))) {
          console.log('already exists - individual to team registration');
          return;
        }
      }
      state.registrations.push(registration);
      state.registrations = reApplyDiscountForMultiPurchase(state.registrations);
    },
    edit(state, registration) {
      const index = _.findIndex(state.registrations, (re) => re.product._id === registration.product._id);
      console.log('edit', registration, index);
      if (index < 0) {
        return;
      }

      state.registrations[index] = registration;
      state.registrations = reApplyDiscountForMultiPurchase(state.registrations);
    },
    addSaleableItem(state, saleableItems) {
      console.log('addSaleableItem', saleableItems);
      saleableItems.forEach((saleableItem) => {
        const foundIndex = _.findIndex(state.saleableItems, (item) => item._id === saleableItem._id);
        if (foundIndex > -1) {
          state.saleableItems[foundIndex].qty += saleableItem.qty;
        } else {
          state.saleableItems.push(saleableItem);
        }
      });
    },
    updateDirectStoreItems(state, { saleableItems }) {
      console.log('updateDirectStoreItems', saleableItems);
      state.saleableItems = saleableItems;
    },
    addMembership(state, rego) {
      Object.assign(state.membershiptoUpgrade, rego);
    },
    update(state, { unusedIndex, registration }) {
      // state.registrations[index] = registration;
      console.log(unusedIndex, 'unusedIndex');
      let index;
      if (registration.isBulk) {
        index = _.findIndex(state.registrations, (r) => r.product._id === registration.product._id && r.isBulk);
      } else {
        index = _.findIndex(state.registrations, (r) => r.product._id === registration.product._id && r.memberId === registration.memberId);
      }
      state.registrations[index] = registration;
      state.registrations = reApplyDiscountForMultiPurchase(state.registrations);
    },
    remove(state, index) {
      state.registrations.splice(index, 1);
      state.registrations = reApplyDiscountForMultiPurchase(state.registrations);
    },
    clear(state) {
      state.registrations = [];
      state.saleableItems = [];
      state.pendingRequiredRegos = [];
    },
    clearTeam(state) {
      state.registrations = _.filter(state.registrations, (rego) => rego.productType !== 'team');
    },
    clearPendingRequiredRegos(state) {
      state.pendingRequiredRegos = [];
    },
    clearTeamRegistrations(state) {
      state.registrations = _.filter(state.registrations, (rego) => rego.productType !== 'team');
    },
    deleteAllIndvRegistrations(state) {
      state.registrations = _.filter(state.registrations, (rego) => rego.productType !== 'indv' || rego.isBulk);
    },
    deleteAllTeamRegistrations(state) {
      state.registrations = _.filter(state.registrations, (rego) => rego.productType !== 'team');
    },
    deleteAllIndvToTeamRegistrations(state) {
      state.registrations = _.filter(state.registrations, (rego) => rego.productType !== 'indv-to-team');
    },
    deleteAllBulkRegistrations(state) {
      state.registrations = _.filter(state.registrations, (rego) => rego.productType !== 'bulk');
    },
    deleteAllRegistrations(state) {
      state.registrations = [];
    },
    clearConfirmation(state) {
      state.confirmation = [];
      state.registrations = [];
      state.saleableItems = [];
      state.regoDiscounts = [];
      state.selectedBulkMembers = [];
      state.membershiptoUpgrade = {};
      state.pendingRegistration = undefined;
      state.pendingRequiredRegos = [];
    },
    setTransactionFee(state, payload) {
      state.transactionFee = payload;
    },
    setCurrentMember(state, payload) {
      console.log(payload, 'payloadxxxx');
      state.currentMember = payload;
    },
    setRegoDiscounts(state, { index, payload }) {
      state.regoDiscounts[index].productIds.push(payload);
    },
    updateRegoDiscounts(state, payload) {
      state.regoDiscounts = payload;
    },
    clearDiscounts(state) {
      state.regoDiscounts = {};
    },
    setSelectedBulkMembers(state, payload) {
      state.selectedBulkMembers = payload;
    },
    updateRego(state, { regoIndex, memberId }) {
      state.registrations[regoIndex].memberIds = _.filter(state.registrations[regoIndex].memberIds, (id) => id !== memberId);
      state.selectedBulkMembers = _.filter(state.selectedBulkMembers, (member) => member._id !== memberId);
    },
    removeRegistration(state, payload) {
      const index = _.findIndex(state.registrations, (reg) => {
        if (reg.product._id !== payload.productId) return false;
        if (reg.productType !== payload.productType) return false;

        switch (payload.productType) {
          case 'indv':
          case 'indv-to-team':
            return reg.memberId === payload.memberId;
          case 'team':
            return reg.team.name === payload.teamName;
          case 'bulk':
            return reg.isBulk;
          case 'family':
            return true; // Assuming family registrations are unique by product
          default:
            return false;
        }
      });

      if (index !== -1) {
        state.registrations.splice(index, 1);
        state.registrations = reApplyDiscountForMultiPurchase(state.registrations);
      }
    },
  },
  actions: {
    removeRegistration({ commit }, payload) {
      commit('removeRegistration', payload);
    },
  },
  getters: {
    indvCartTotal(state) {
      return state.indvCartTotal;
    },
    indvPayTodayTotal(state) {
      return state.indvPayTodayTotal;
    },
    registrations(state) {
      return state.registrations;
    },
    totalWithSaleableItems(state) {
      console.log('totalWithSaleableItems', state.totalWithSaleableItems);
      return state.totalWithSaleableItems;
    },
    totalDiscount(state) {
      return state.totalDiscount;
    },
    currentConfirmation: (state) => state.confirmation,
    membershiptoUpgrade(state) {
      return state.membershiptoUpgrade;
    },
    pendingRegistration(state) {
      return state.pendingRegistration;
    },
    pendingRequiredRegos(state) {
      return state.pendingRequiredRegos;
    },
    counts(state) {
      const saleableItemsCount = _.reduce(state.saleableItems, (sum, item) => sum + item.qty, 0);
      return state.registrations.length + saleableItemsCount;
    },
    transactionFee(state) {
      return state.transactionFee;
    },
    familyRegistrations(state) {
      return state.familyRegistrations;
    },
    getCurrentMember(state) {
      return state.currentMember;
    },
    directSaleableItems(state) {
      return state.saleableItems;
    },
    regoDiscounts(state) {
      return state.regoDiscounts;
    },
    codesInUsed(state) {
      return _.map(state.regoDiscounts, (discount) => _.get(discount, 'discountVoucher.code'));
    },
    cTotalDiscount(state) {
      return _.find(state.regoDiscounts, (discount) => discount.type === 'checkoutTotal');
    },
    selectedBulkMembers(state) {
      return state.selectedBulkMembers;
    },
  },
};
